import { Mail, MapPin, Sparkles } from "lucide-react";
import { NAV_LINKS, CONTACT_EMAIL, LOCATION } from "@/data";
import { useApply } from "@/context";

export default function Footer() {
  const { openApply } = useApply();
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-deep-trust-blue pt-20 text-white">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 gap-12 pb-16 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="grid h-9 w-9 place-items-center rounded-xl bg-vibrant-orange text-white">
                <Sparkles size={18} strokeWidth={2.5} />
              </span>
              <span className="font-heading text-xl font-extrabold tracking-tight">
                Unnati<span className="text-emerald-green"> AI</span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/60">
              India&apos;s first voice-first AI skilling movement — building livelihoods where roots run deep.
              An initiative by Unevo Consultant Pvt. Ltd.
            </p>
            <button
              data-testid="footer-apply-btn"
              onClick={() => openApply()}
              className="mt-7 rounded-full bg-vibrant-orange px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-orange-600"
            >
              Apply Now
            </button>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-semibold uppercase tracking-widest text-white/40">Explore</h4>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-white/70 transition-colors hover:text-emerald-green">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-semibold uppercase tracking-widest text-white/40">Get in touch</h4>
            <ul className="mt-5 space-y-4 text-sm text-white/70">
              <li>
                <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email" className="inline-flex items-center gap-3 transition-colors hover:text-emerald-green">
                  <Mail size={18} className="text-emerald-green" /> {CONTACT_EMAIL}
                </a>
              </li>
              <li className="inline-flex items-start gap-3">
                <MapPin size={18} className="mt-0.5 shrink-0 text-emerald-green" /> {LOCATION}
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-white/10 py-8 md:flex-row">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} Unevo Consultant Pvt. Ltd. All rights reserved.
          </p>
          <p className="text-xs text-white/50">Made with purpose in Ranchi, Jharkhand 🇮🇳</p>
        </div>
      </div>

      {/* Massive brand hit */}
      <div className="select-none overflow-hidden">
        <p className="translate-y-6 text-center font-heading text-[22vw] font-extrabold leading-none tracking-tighter text-white/[0.04]">
          UNEVO
        </p>
      </div>
    </footer>
  );
}
